const Mutations = Object.freeze({
	SET_REPORTS: 'reportBuilderModule/reportBuilder/SET_REPORTS',
	ADD_REPORT: 'reportBuilderModule/reportBuilder/ADD_REPORT',
	ADD_WORKBOOK: 'reportBuilderModule/reportBuilder/ADD_WORKBOOK',
	SET_WORKBOOKS: 'reportBuilderModule/reportBuilder/SET_WORKBOOKS',
	SET_LOADING_REPORTS:
		'reportBuilderModule/reportBuilder/SET_LOADING_REPORTS',
	SET_LOADING_WORKBOOKS:
		'reportBuilderModule/reportBuilder/SET_LOADING_WORKBOOKS',
});

export const Actions = Object.freeze({
	CLEAR: 'reportBuilderModule/reportBuilder/CLEAR',
	LOAD_REPORTS: 'reportBuilderModule/reportBuilder/LOAD_REPORTS',
	LOAD_WORKBOOKS: 'reportBuilderModule/reportBuilder/LOAD_WORKBOOKS',
	DELETE_REPORT: 'reportBuilderModule/reportBuilder/DELETE_REPORT',
	DELETE_WORKBOOK: 'reportBuilderModule/reportBuilder/DELETE_WORKBOOK',
	DOWNLOAD_REPORT: 'reportBuilderModule/reportBuilder/DOWNLOAD_REPORT',
	DOWNLOAD_WORKBOOK: 'reportBuilderModule/reportBuilder/DOWNLOAD_WORKBOOK',
	CLONE_REPORT: 'reportBuilderModule/reportBuilder/CLONE_REPORT',
	CLONE_WORKBOOK: 'reportBuilderModule/reportBuilder/CLONE_WORKBOOK',
});
export const Getters = Object.freeze({
	LOADING_REPORTS: 'reportBuilderModule/reportBuilder/LOADING_REPORTS',
	LOADING_WORKBOOKS: 'reportBuilderModule/reportBuilder/LOADING_WORKBOOKS',
	REPORTS: 'reportBuilderModule/reportBuilder/REPORTS',
	WORKBOOKS: 'reportBuilderModule/reportBuilder/WORKBOOKS',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/reportBuilderService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';
import Snackbar from '../../../../../components/core/dialogs/snackbarMessage';
export default {
	state: {
		reports: [],
		workbooks: [],
		loadingReports: false,
		loadingWorkbooks: false,
	},
	mutations: {
		[Mutations.SET_REPORTS](state, items) {
			state.reports = items;
		},
		[Mutations.ADD_REPORT](state, item) {
			state.reports.push(item);
		},
		[Mutations.ADD_WORKBOOK](state, item) {
			state.workbooks.push(item);
		},
		[Mutations.SET_WORKBOOKS](state, items) {
			state.workbooks = items;
		},
		[Mutations.SET_LOADING_REPORTS](state, val) {
			state.loadingReports = val;
		},
		[Mutations.SET_LOADING_WORKBOOKS](state, val) {
			state.loadingWorkbooks = val;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_WORKBOOKS, []);
				commit(Mutations.SET_REPORTS, []);
				commit(Mutations.SET_LOADING_REPORTS, false);
				commit(Mutations.SET_LOADING_WORKBOOKS, false);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_REPORTS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING_REPORTS, true);
				dataService
					.getReports()
					.then((resp) => {
						commit(Mutations.SET_REPORTS, resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING_REPORTS, false);
						resolve();
					});
			});
		},

		[Actions.LOAD_WORKBOOKS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING_WORKBOOKS, true);
				dataService
					.getWorkbooks()
					.then((resp) => {
						commit(Mutations.SET_WORKBOOKS, resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING_WORKBOOKS, false);
						resolve();
					});
			});
		},

		[Actions.DELETE_REPORT]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteReport(item)
					.then(() => {
						let reports = state.reports;
						let report = reports.find((x) => x.Id == item.Id);
						if (report) {
							let index = reports.indexOf(report);
							reports.splice(index, 1);
						}
						commit(Mutations.SET_REPORTS, reports);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.DELETE_WORKBOOK]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteWorkbook(item)
					.then(() => {
						let workbooks = state.workbooks;
						let workbook = workbooks.find((x) => x.Id == item.Id);
						if (workbook) {
							let index = workbooks.indexOf(workbook);
							workbooks.splice(index, 1);
						}
						commit(Mutations.SET_WORKBOOKS, workbooks);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DOWNLOAD_REPORT](
			{ dispatch },
			{ item, isDirectMode = ExportMode.DIRECT }
		) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				if (isDirectMode === ExportMode.DIRECT) {
					exportDataService
						.downloadReportDirect(item)
						.then((resp) => {
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const filename = fileInfo.filename;

							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode
					exportDataService
						.downloadReport(item)
						.then(() => {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
		[Actions.DOWNLOAD_WORKBOOK](
			{ dispatch },
			{ item, isDirectMode = ExportMode.DIRECT }
		) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				if (isDirectMode === ExportMode.DIRECT) {
					exportDataService
						.downloadWorkbookDirect(item)
						.then((resp) => {
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const filename = fileInfo.filename;

							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode
					exportDataService
						.downloadWorkbook(item)
						.then(() => {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
		[Actions.CLONE_REPORT]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.cloneReport(item)
					.then((resp) => {
						commit(Mutations.ADD_REPORT, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.CLONE_WORKBOOK]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.cloneWorkbook(item)
					.then((resp) => {
						commit(Mutations.ADD_WORKBOOK, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.LOADING_REPORTS]: (state) => {
			return state.loadingReports;
		},
		[Getters.LOADING_WORKBOOKS]: (state) => {
			return state.loadingWorkbooks;
		},
		[Getters.REPORTS]: (state) => {
			if (!state.reports) return [];
			if (state.reports.length <= 0) return [];
			return JSON.parse(
				JSON.stringify(
					state.reports.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				)
			);
		},
		[Getters.WORKBOOKS]: (state) => {
			if (!state.workbooks) return [];
			if (state.workbooks.length <= 0) return [];
			return JSON.parse(
				JSON.stringify(
					state.workbooks.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				)
			);
		},
	},
};
